module.exports = __webpack_public_path__ + "static/media/ZSCE.7a4ed20a.pdf";